import { procurementAPI } from "../../axios";

export const actions = {
    GetBidActivityScheduleByRfq(context, data){
        return procurementAPI.get(`BidActivitySchedule/Rfq/${data}`);
    },
    GetSingleBidActivitySchedule(context, data){
        return procurementAPI.get(`BidActivitySchedule/${data}`);
    },
    UpdateBidActivitySchedule(context, data){
        return procurementAPI.put(`BidActivitySchedule/Update/${data.id}`, data);
    },
    DeleteBidActivitySchedule(context, data){
        return procurementAPI.delete(`BidActivitySchedule/Remove/${data}`);
    },
    CreateBidActivitySchedule(context, data){
        return procurementAPI.post(`BidActivitySchedule/Add`, data);
    },
}